import { createElement } from 'react';
/**
 * Heading — semantic heading wrapper. Picks the right `<h{level}>` tag
 * via `createElement`, then applies the heading reset styles from
 * `_base.scss`. One `<h1>` per page; everything else should use 2–6.
 *
 * @example
 *   <Heading level={1}>Users</Heading>
 *   <Heading level={3}>Permissions</Heading>
 */
export function Heading({ level = 2, className, children, ...rest }) {
    const tag = `h${level}`;
    const classes = ['osd-heading', className].filter(Boolean).join(' ');
    return createElement(tag, { className: classes, ...rest }, children);
}
//# sourceMappingURL=Heading.js.map